import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Sales overview',
    icon: { icon: 'chart-line', pack: 'fas' },
    link: '/pages/:eventId/sales',
    home: true
  },
  {
    title: 'All users',
    icon: { icon: 'users', pack: 'fas' },
    link: '/pages/:eventId/users'
  },
  {
    title: 'Managers',
    icon: { icon: 'user-tie', pack: 'fas' },
    link: '/pages/:eventId/managers'
  },
  {
    title: 'Token generators',
    icon: { icon: 'coins', pack: 'fas' },
    link: '/pages/:eventId/tokengenerators'
  },
  {
    title: 'Bartenders',
    icon: { icon: 'users-cog', pack: 'fas' },
    link: '/pages/:eventId/bartenders'
  },
  {
    title: 'Marketing',
    icon: { icon: 'comments', pack: 'fas' },
    link: '/pages/:eventId/marketing'
  },
  {
    title: 'Event details',
    icon: { icon: 'cogs', pack: 'fas' },
    link: '/pages/:eventId/eventdetails'
  },
  {
    title: 'Pricelist',
    icon: { icon: 'glass-martini-alt', pack: 'fas' },
    link: '/pages/:eventId/pricelist'
  },
  {
    title: 'Invoice requests',
    icon: { icon: 'receipt', pack: 'fas' },
    link: '/pages/:eventId/invoicerequests'
  },
  {
    title: 'QR generator',
    icon: { icon: 'qrcode', pack: 'fas' },
    link: '/pages/:eventId/generator'
  },
  {
    title: 'HorecaTouch',
    icon: { icon: 'laptop', pack: 'fas' },
    link: '/pages/:eventId/horeca-touch'
  },
  {
    title: 'Change event',
    icon: { icon: 'exchange-alt', pack: 'fas' },
    link: '/manager'
  }
];
